module.exports = __webpack_public_path__ + "3e9c3cda53e327abeafd1dba4213df2f.pdf";